import { render } from "./WarehouseItemContextMenu.vue?vue&type=template&id=31ee2402"
import script from "./WarehouseItemContextMenu.vue?vue&type=script&lang=js"
export * from "./WarehouseItemContextMenu.vue?vue&type=script&lang=js"

import "./WarehouseItemContextMenu.vue?vue&type=style&index=0&id=31ee2402&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__